import { cardItems } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">精选推荐</h2>
          <p className="mt-2 text-sm text-foreground-600">精心整理的黑料网站相关文章与资源指南</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {cardItems.map((card) => (
            <article
              key={card.id}
              className="group bg-background-100 rounded-lg overflow-hidden border border-background-200 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative w-full aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={card.image}
                  alt={card.alt}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  onError={(e) => { e.currentTarget.style.display = 'none'; }}
                />
                <span className="absolute top-3 left-3 px-2.5 py-0.5 text-[11px] font-semibold text-background-50 bg-primary-500/90 rounded-md">
                  {card.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 leading-snug group-hover:text-primary-500 transition-colors line-clamp-2">
                  {card.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-600 leading-relaxed line-clamp-3">{card.summary}</p>
                <a
                  href={card.link}
                  className="inline-flex items-center gap-1 mt-3 text-xs font-medium text-primary-500 hover:text-primary-600 transition-colors"
                >
                  了解更多
                  <i className="ri-arrow-right-line text-xs"></i>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}